/**
 * /tenants/$slug/provisioning/new — route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import { NewConnectionPage } from "@/features/provisioning/pages/new-connection-page";

export const Route = createFileRoute("/_authed/tenants/$slug/provisioning/new")({
  component: NewConnectionPage,
});
